export default __webpack_public_path__ + "static/media/1791.6bfaa962.png";